module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/solid/pennant.svg?3a2350ffa202a3f010e2e5c084baf189";